<template>
    <b-row>   
        <b-col cols="12">
            <div class="text-right mb-4">
                <Button @click="showModal('descargar-informe')" icon="fa fa-download"  class="width-responsive">DESCARGAR INFORME + DETALLE</Button>
                <Button class="ml-2 width-responsive" @click="showModal('descargar-informe-economico')" icon="fa fa-download">DESCARGAR INFORME ECONOMICO</Button>
                
                <router-link :to="{ name: 'back.abonos.informe.emails', params:{ lista_id: lista_id } }" class="btn btn-primary ml-2 width-responsive">
                    <i class="fa fa-chart-line"></i> ESTADÍSTICAS EMAILS
                </router-link>

                <router-link :to="{ name: 'back.abonos.informe.plazos-impagados' }" class="btn btn-primary ml-2 width-responsive">
                    <i class="fa fa-euro-sign mr-1"></i>Estado de plazos
                </router-link>

                <DescargarInforme :ruta="'back.abonos.informe.export.excel'" :url="url_informe" v-on:close="closeModal" name="descargar-informe-economico" :detalle="false" :lista_id="lista_id"></DescargarInforme>
                <DescargarInforme :ruta="'back.abonos.informe.export.excel'" :url="url_informe" v-on:close="closeModal" name="descargar-informe" :detalle="true" :lista_id="lista_id"></DescargarInforme>
            </div>
        </b-col>
        <b-col cols="12" md="4">
            <TotalRecaudacionComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" :tipo="'ABONOS'" id="total-recaudacion"></TotalRecaudacionComponent>
        </b-col>
        <b-col cols="12" md="4" class="mb-3">
            <GraficosComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" id="graficos-ventas"></GraficosComponent>
        </b-col>
        <b-col cols="12" md="4">
            <VentaDiariaComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin" id="venta-diaria"></VentaDiariaComponent>
        </b-col>
        <b-col cols="12">
            <TablaAbonosSeccionPreciosComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin"/>
        </b-col>
        <b-col cols="12">
            <AbonosPreciosComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin"/>
        </b-col>
        <b-col cols="12">
            <TablaRecaudacionSeccionPreciosComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin"/>
        </b-col>
        <b-col cols="12">
            <RecaudacionPreciosComponent :lista_id="lista_id" :fecha_inicio="fecha_inicio" :fecha_fin="fecha_fin"/>
        </b-col>
    </b-row>
</template>

<script>
import TotalRecaudacionComponent from '@/components/backend/estadisticas/common/TotalRecaudacionComponent';
import GraficosComponent from '@/components/backend/estadisticas/abonos/GraficosComponent';
import VentaDiariaComponent from '@/components/backend/estadisticas/abonos/VentaDiariaComponent';
import TablaAbonosSeccionPreciosComponent from './TablaAbonosSeccionPreciosComponent.vue';
import AbonosPreciosComponent from './AbonosPreciosComponent.vue';
import TablaRecaudacionSeccionPreciosComponent from './TablaRecaudacionSeccionPreciosComponent.vue';
import RecaudacionPreciosComponent from './RecaudacionPreciosComponent.vue';
import DescargarInforme from '@/components/backend/components/DescargarInforme';

export default {
    props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
    methods: {
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.$modal.hide(modal);
        }
    },
    computed: {
        url_informe() {
            return this.config.API_BASE + '/listas-abonados/' + this.lista_id + '/informe?api_key=' + localStorage.getItem('token');
        }
    },
    components: {
        TotalRecaudacionComponent, VentaDiariaComponent, GraficosComponent,
        TablaAbonosSeccionPreciosComponent, AbonosPreciosComponent, TablaRecaudacionSeccionPreciosComponent, RecaudacionPreciosComponent, DescargarInforme
    }
}
</script>

<style scoped>
     @media (max-width: 700px) {
        .width-responsive {
            width: 100%;
            margin-bottom: 5px;
            margin-left: 0 !important;
        }
     }
</style>